import { MeasureData } from "../interfaces";

/**
 * Tape values in inches, for the US Navy formula.
 *
 * The cm path used to floor each converted value to a whole inch. Nothing in
 * the formula wants that, the mm path never did it, and flooring rather than
 * rounding biased every reading downwards — but the real damage was
 * resolution. A whole inch is 2.54 cm, so a client losing 2 cm off the waist
 * could see no change at all, and often did:
 *
 *   Daniel, 181 cm, waist 108 -> 106 -> 104 -> 102, neck 41.5 -> 40.2
 *     floored   28.8, 27.3, 27.3, 27.3 %   <- three scans identical
 *     exact     28.9, 28.0, 27.2, 26.2 %
 *
 * Six centimetres of waist showed as 1.5 points instead of 2.7. The product's
 * whole claim is that it can see change; this quantised it away.
 */
export const getBfValues = (measurements: MeasureData['measurements'], gender: 'male' | 'female', unit: 'mm' | 'cm') => {
    const waist = (gender === 'female' ? measurements.waist_female : measurements.waist) / 2.54;

    const neck = measurements.neck / 2.54;
    const height = measurements.height / 2.54;

    const hip = measurements.buttocks / 2.54;
    if (unit === 'mm') {
        return { waist: waist / 10.0, neck: neck / 10.0, height: height / 10.0, hip: hip / 10.0 };
    }
    return { waist, neck, height, hip };
}

// Add this function to calculate body fat percentage
export const calculateBodyFat = (measurements: MeasureData['measurements'], gender: 'male' | 'female', unit: 'mm' | 'cm' = 'mm'): number => {
    // Example calculation logic, replace with actual logic

    let { waist, neck, height, hip } = getBfValues(measurements, gender, unit);

    if (gender === "male") {
        return (
            86.01 * Math.log10(waist - neck) - 70.041 * Math.log10(height) + 36.76
        );
    } else {
        return (
            163.205 * Math.log10(waist + hip - neck) -
            97.684 * Math.log10(height) -
            78.387
        );
    }
};
